module.exports = __webpack_public_path__ + "img/logo-numbers.cf9c6324.jpg";